import { render } from "./fabricCanvas.vue?vue&type=template&id=1608c4e0&scoped=true"
import script from "./fabricCanvas.vue?vue&type=script&lang=js"
export * from "./fabricCanvas.vue?vue&type=script&lang=js"

import "./fabricCanvas.vue?vue&type=style&index=0&id=1608c4e0&scoped=true&lang=css"

import exportComponent from "/var/www/clients/client2/web300/web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1608c4e0"]])

export default __exports__